import EventAlertPositive from './EventAlertPositive';

export default EventAlertPositive;
